<ng-container [ngSwitch]="isDashboard">
  <ng-container *ngSwitchCase="true">
    <ng-container *ngTemplateOutlet="landingHeader"> </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="false">
    <ng-container *ngTemplateOutlet="dashboardHeader"></ng-container>
  </ng-container>
</ng-container>

<ng-template #landingHeader>
  <div
    class="head-Section ui large secondary fixed borderless menu"
    *ngIf="listingHeader"
    #nav
  >
    <div class="ui container" [ngClass]="{ fluid: !isShowListing }">
      <a class="header" [routerLink]="['']">
        <img
          src="assets/images/signgaze-logo.svg"
          *ngIf="howItWorksHeader"
          class="company-logo"
        />
        <img
          src="assets/images/signgaze-logo.svg"
          *ngIf="!howItWorksHeader"
          class="company-logo"
        />
      </a>
      <div class="right menu">
        <a
          class="item pure-hidden-xs"
          routerLinkActive="active"
          title="Advertisers"
          [routerLink]="['/listings']"
        >
          Advertisers
        </a>
        <a
          class="item pure-hidden-xs"
          routerLinkActive="active"
          title="Own a Screen?"
          [routerLink]="['/screen-manager']"
        >
          Own a Screen?
        </a>
        <a
          class="item pure-hidden-xs"
          routerLinkActive="active"
          title="How it Works"
          [routerLink]="['/how-it-works']"
        >
          How it Works
        </a>
        <a class="item checkout-icon" [routerLink]="['/checkout']">
          <i class="shopping bag icon"></i>
          <div
            class="ui bottom floating primary label"
            *ngIf="(currentBookedScreens$ | async)?.length > 0"
          >
            {{ (currentBookedScreens$ | async)?.length }}
            <span class="pure-hidden-xs">screen</span>
          </div>
        </a>
        <div *ngIf="auth.user | async; then authenticated; else guest"></div>
        <ng-template #guest>
          <div class="right menu">
            <div class="item">
              <a class="signup-link" title="Sign up" [routerLink]="['/login']">
                Sign up
              </a>
            </div>
          </div>
        </ng-template>
        <ng-template #authenticated>
          <div class="right menu">
            <div
              class="ui right inverted dropdown item"
              *ngIf="auth.user | async as user"
              fuiDropdown
              autoClose="outsideClick"
            >
              <img
                class="ui avatar image"
                [src]="
                  user?.photoURL ||
                  'https://api.adorable.io/avatars/109/fire.png'
                "
              />
              <span class="user-name pure-hidden-xs pure-hidden-sm">{{
                user.displayName
              }}</span>
              <i
                class="inverted dropdown icon pure-hidden-xs pure-hidden-sm"
              ></i>
              <div class="menu" fuiDropdownMenu>
                <div class="item" routerLink="/dashboard">Dashboard</div>
                <div class="item" (click)="logout()">Log Out</div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="ui right-dropdown dropdown" fuiDropdown>
        <i class="sidebar icon"></i>
        <div class="menu" fuiDropdownMenu>
          <a [routerLink]="['/listings']" class="item"> Advertisers </a>
          <a [routerLink]="['/screen-manager']" class="item">Own a Screen?</a>
          <a [routerLink]="['/how-it-works']" class="item">How it Works</a>
          <a
            [routerLink]="['/login']"
            class="item"
            *ngIf="(auth.user | async) === null"
            >Login</a
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #dashboardHeader>
  <header>
    <div
      class="
        ui
        small
        borderless
        menu
        dashboard-menu
        no
        shadow
        no
        border
        pure-hidden-xs pure-hidden-sm pure-hidden-md
      "
      style="border-radius: 10px !important"
    >
      <div class="item">
        <div class="header item logo-item separator">
          <a>
            <img class="ui small image" src="assets/images/signgaze-logo.svg"
          /></a>
        </div>
      </div>

      <div class="right item">
        <a class="item" title="Advertisers" [routerLink]="['/listings']">
          Advertisers
        </a>
        <a
          class="item"
          title="Own a Screen?"
          [routerLink]="['/screen-manager']"
        >
          Own a Screen?
        </a>
        <a class="item checkout-icon" [routerLink]="['/checkout']">
          <i class="shopping bag icon"></i>
          <div
            class="ui bottom floating primary label"
            *ngIf="(currentBookedScreens$ | async)?.length > 0"
          >
            {{ (currentBookedScreens$ | async)?.length }}
            <span class="pure-hidden-xs">screen</span>
          </div>
        </a>
        <div
          class="ui pointing dropdown item"
          *ngIf="auth.user | async as user"
          autoClose="outsideClick"
          fuiDropdown
        >
          <img
            class="ui avatar image"
            [src]="
              user?.photoURL || 'https://api.adorable.io/avatars/109/fire.png'
            "
          />
          {{ user.displayName }}
          <i class="dropdown icon"></i>
          <div class="menu" fuiDropdownMenu>
            <div class="item" (click)="logout()">Logout</div>
          </div>
        </div>
      </div>
    </div>
  </header>
</ng-template>
